// axios
import axios from "axios"

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

// Vue 3: $http will be set in main.js via app.config.globalProperties
export default axiosIns
